<template>
    <div class="page-setting has-bc biz-add-account-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="default-button publish" @click="saveData" :disabled="status.isDisable">新增</button>
                </div>
            </div>
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                帳密
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 電子郵件帳號
                        </div>
                        <span v-show="error.email" class="error-with-title">{{error.email}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.email}" type="text" v-model="insertData.email" placeholder="請輸入電子郵件帳號">
                    </div>
                </div>
                <!-- <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 密碼
                        </div>
                        <span v-show="error.password" class="error-with-title">{{error.password}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.password}" type="text" v-model="insertData.password" placeholder="請輸入密碼">
                    </div>
                </div> -->
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                基本資料
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 員工真實姓名
                        </div>
                        <span v-show="error.name" class="error-with-title">{{error.name}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.name}" type="text" v-model="insertData.name" placeholder="請輸入員工真實姓名">
                        <div class="input-note" @mouseenter="tipStatus.agent=true" @mouseleave="tipStatus.agent=false">員工姓名會呈現在哪裡？</div>
                        <title-tips v-if="tipStatus.agent" class="tips-agent" title="廣告頁面的聯絡人" width="424px">
                            <div class="content" slot="content">
                                <div class="ad-title">
                                    廣告名稱
                                </div>
                                <div class="rent">
                                    28,000 <span class="unit">元 / 月</span>
                                </div>
                                <div class="agent">
                                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                                    <div class="name">{{insertData.name?insertData.name:'員工姓名'}}</div>
                                    <div class="phone">{{insertData.phoneNumber?insertData.phoneNumber:'0912345678'}}</div>
                                    <img src="@/assets/img/icon/phone_blue.svg" alt="">
                                </div>
                            </div>
                        </title-tips>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 手機號碼
                        </div>
                        <span v-show="error.phoneNumber" class="error-with-title">{{error.phoneNumber}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.phoneNumber}" type="text" v-model="insertData.phoneNumber" placeholder="請輸入手機號碼">
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                分配群組
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 職務部門
                        </div>
                        <span v-show="error.roleId" class="error-with-title">{{error.roleId}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select class="select-scroll" :class="{error: error.roleId}" refName="role" selectMsg="請選擇職務部門" @getId="getSelectId"  bgColor="#fff">
                            <ul>
                                <li v-for="(list, index) in employeeRoleList" :key="index" :data-id="list.id" :data-name="list.roleName">
                                    {{list.roleName}}
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 業務分群
                        </div>
                        <span v-show="error.groupId" class="error-with-title">{{error.groupId}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select class="select-scroll" :class="{error: error.groupId}" refName="group" selectMsg="請選擇業務分群" @getId="getSelectId"  bgColor="#fff">
                            <ul>
                                <li v-for="(list, index) in organizationGroupList" :key="index" :data-id="list.id" :data-name="list.groupName">
                                    {{list.groupName}}
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            insertData: {
                email: '',
                password: '',
                name: '',
                phoneNumber: '',
                roleId: '',
                groupId: '',
            },
            error: {
                email: null,
                password: null,
                name: null,
                phoneNumber: null,
                roleId: null,
                groupId: null,
            },
            status: {
                isDisable: false,
            },
            tipStatus: {
                agent: false
            },
        }
    },
    mounted () {
        this.getEmployeeRoleList();
        this.getOrganizationGroupList();
    },
    watch: {
        insertData: {
            handler: function (newValue, oldValue) {
                if(newValue.email){
                    let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
                    if (!isMail.test(newValue.email)) {
                        this.error.email = '電子郵件格式錯誤';
                    }else{
                        this.error.email = null;
                    }
                }
                let phoneReg = /^09[0-9]{8}$/;
                if( newValue.phoneNumber ){
                    if(!phoneReg.test(newValue.phoneNumber) || newValue.phoneNumber.length > 10 ) {
                        this.error.phoneNumber = '格式錯誤';
                    }else{
                        this.error.phoneNumber = null;
                    }
                }
                if(newValue.roleId){
                    this.error.roleId = null
                }
                if(newValue.groupId){
                    this.error.groupId = null
                }
                if(newValue.name){
                    this.error.name = null
                }
            },
            deep: true,
        }
    },
    methods: {
        getEmployeeRoleList: function () {
            this.$store.dispatch('getBizEmployeeRoleList')
        },
        getOrganizationGroupList: function () {
            this.$store.dispatch('getBizOrganizationGroupList')
        },
        checkInput: function () {
            if(this.insertData.email == ''){
                this.error.email = '請填寫電子郵件帳號';
            }
            // if(this.insertData.password == ''){
            //     this.error.password = '請填寫密碼';
            // }else{
            //     this.error.password = null;
            // }
            if(this.insertData.name == ''){
                this.error.name = '請填寫員工真實姓名';
            }
            if(this.insertData.phoneNumber == ''){
                this.error.phoneNumber = '請填寫手機號碼';
            }
            if(this.insertData.roleId == ''){
                this.error.roleId = '請選擇職務部門';
            }
            if(this.insertData.groupId == ''){
                this.error.groupId = '請選擇業務分群';
            }

            if(this.error.email == null && 
                // this.error.password == null &&
                this.error.name == null &&
                this.error.phoneNumber == null && 
                this.error.roleId == null &&
                this.error.groupId == null &&
                this.insertData.email != '' &&
                // this.insertData.password != '' &&
                this.insertData.name != '' &&
                this.insertData.phoneNumber != '' && 
                this.insertData.roleId != '' &&
                this.insertData.groupId != ''){
                return true 
            }else{
                return false
            }
        },
        saveData: function () {
            if(this.checkInput()){
                this.status.isDisable = true
                this.$analyticsBiz.logEvent('新增帳號', { screen_name: '新增帳號'})

                this.$store.dispatch('insertBizAccount', this.insertData)
                .then(res => {
                    this.status.isDisable = false
                    if( res.data.status == "SUCCESS" ){
                        this.$router.push({ name: 'bizAccountMgt', query: { success: '1' }})
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
            }
        },
        getSelectId: function (value) {
            let targetId = value.id
            if( value.ref == 'role' ){
                this.insertData.roleId = targetId
            }else if( value.ref == 'group'){
                this.insertData.groupId = targetId
            }
        },
    },
    computed: {
        ...mapGetters({
            employeeRoleList: 'GET_BIZ_EMPLOYEE_ROLE_LIST',
            organizationGroupList: 'GET_BIZ_ORGANIZATION_GROUP_LIST',
        })
    },
    components: {
        toogleBlock,
        RentSelect,
        btnLoading,
        titleTips
    }
}
</script>
<style lang="scss">
    .biz-add-account-comp{
        padding-bottom: 300px;
        .page-header{
            .btn-group{
                .loading-wrap{
                    position: relative;
                    width: 100%;
                    .default-button{
                        width: 120px;
                        padding: 14px 0 14px 0;
                    }
                    .btn-loading{
                        left: 5px;
                        top: 6px;
                    }
                }
            }
        }
        .toggle-block > .toogle-body {
            padding: 0 60px 24px 24px;
            .tips-agent{
                font-size: 20px;
                font-weight: 500;
                .ad-title{
                    margin-bottom: 10px;
                }
                .rent{
                    color: #a19d9c;
                    margin-bottom: 16px;
                    .unit{
                        font-size: 14px;
                    }
                }
                .agent{
                    display: flex;
                    align-items: center;
                    .name{
                        color: #fc7171;
                        margin-left: 8px;
                        margin-right: 12px;
                    }
                    .phone{
                        margin-right: 10px;
                        color: #3a455f;
                    }
                }
            }
        }
        .must-fill-alarm{
            position: relative;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            color: #676362;
            padding: 0 24px;
            .star{
                color: #fc7171;
                margin: 0 2px;
            }
            img{
                margin-right: 2px;
            }
        }
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .row-block {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .col2-input {
            position: relative;
            width: 424px;
            margin-bottom: 24px;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/accountMgt/addAccountComp.vue